import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take, tap } from 'rxjs/operators';

import { CapicheLoggerService } from 'capiche-logger';
import { UserService } from '../services/user/user.service';
import { CAPICHE_AUTH_CONFIG } from '../capiche-auth.config';

export const redirectIfAuthenticatedGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userService = inject(UserService);
  const config = inject(CAPICHE_AUTH_CONFIG);
  const logger = new CapicheLoggerService('redirect-if-authenticated.guard:', false);
  const postAuthRoute = config.postAuthRoute ?? '/subscribe';

  return userService.currentUser$.pipe(
    tap((user) => {
      logger.log('auth state:', user);
    }),
    take(1),
    map((user) => {
      if (user) {
        logger.log('User logged in – redirecting to', postAuthRoute);
        return router.createUrlTree([postAuthRoute]);
      }
      logger.log('No user – allowing access to /auth');
      return true;
    }),
  );
};
